import { ButtonToggleGroupCheckbox } from './button-toggle-group';
import { CheckboxGroup } from './checkbox-group';
import { DateRange } from './date-range';
import { HotelName } from './hotel-name';
import { Location } from './location';
import { PopularFilter } from './popular-filter';
import { Price } from './price';
import { RadioGroup } from './radio-group';
import { Travelers } from './travelers';

export const fieldMap = {
  destination: Location,
  dateRange: DateRange,
  rooms: Travelers,
  sort: RadioGroup,
  hotelName: HotelName,
  rewards: CheckboxGroup,
  deals: CheckboxGroup,
  star: ButtonToggleGroupCheckbox,
  price: Price,
  lodging: CheckboxGroup,
  amenities: CheckboxGroup,
  regionId: RadioGroup, // neighborhood
  travelerType: CheckboxGroup,
  poi: RadioGroup, // Exp 28074: LS_Top_Attractions_Filter_by_Popularity
  popularFilter: PopularFilter, //Exp 28592: PWA_Contextual_Top_Filters
  guestRating: RadioGroup,
  accessibility: CheckboxGroup, //Exp 30590: HSR_Accessibility_filters
  paymentType: CheckboxGroup,
  bedroomFilter: ButtonToggleGroupCheckbox, // Exp 31385: PWA_VR__Bedrooms_Filter_and_Playback_on_HSR
  propertyStyle: CheckboxGroup,
  commissionTier: CheckboxGroup
};
